/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { Api, ApiList, ApiRequestHeader } from '../../data/interfaces';

export const FETCH_API_REQUEST = 'FETCH_API_REQUEST';
export const FETCH_API_SUCCESS = 'FETCH_API_SUCCESS';
export const FETCH_API_FAILURE = 'FETCH_API_FAILURE';

export const FETCH_API_LIST_REQUEST = 'FETCH_API_LIST_REQUEST';
export const FETCH_API_LIST_SUCCESS = 'FETCH_API_LIST_SUCCESS';
export const FETCH_API_LIST_FAILURE = 'FETCH_API_LIST_FAILURE';

export const FETCH_FEATURED_API_LIST_SUCCESS = 'FETCH_FEATURED_API_LIST_SUCCESS';
export const FEATCH_FEATURED_API_LIST_REQUEST = 'FEATCH_FEATURED_API_LIST_REQUEST';
export const FETCH_FEATURED_API_LIST_FAILURE = 'FETCH_FEATURED_API_LIST_FAILURE';

export const FETCH_MAJOR_VERSION_API_LIST_REQUEST = 'FETCH_MAJOR_VERSION_API_LIST_REQUEST';
export const FETCH_MAJOR_VERSION_API_LIST_SUCCESS = 'FETCH_MAJOR_VERSION_API_LIST_SUCCESS';
export const FETCH_MAJOR_VERSION_API_LIST_FAILURE = 'FETCH_MAJOR_VERSION_API_LIST_FAILURE';

export const FETCH_THUMBNAIL_REQUEST = 'FETCH_THUMBNAIL_REQUEST';
export const FETCH_THUMBNAIL_SUCCESS = 'FETCH_THUMBNAIL_SUCCESS';
export const FETCH_THUMBNAIL_FAILURE = 'FETCH_THUMBNAIL_FAILURE';

export const FETCH_THUMBNAIL_LIST_REQUEST = 'FETCH_THUMBNAIL_LIST_REQUEST';
export const FETCH_THUMBNAIL_LIST_SUCCESS = 'FETCH_THUMBNAIL_LIST_SUCCESS';
export const FETCH_THUMBNAIL_LIST_FAILURE = 'FETCH_THUMBNAIL_LIST_FAILURE';

export const FETCH_GRAPHQL_REQUEST = 'FETCH_GRAPHQL_REQUEST';
export const FETCH_GRAPHQL_SUCCESS = 'FETCH_GRAPHQL_SUCCESS';
export const FETCH_GRAPHQL_FAILURE = 'FETCH_GRAPHQL_FAILURE';

export const SET_SECURITY_HEADERS = 'SET_SECURITY_HEADERS';

export interface ApiActions {
    type: typeof FETCH_API_REQUEST | typeof FETCH_API_SUCCESS | typeof FETCH_API_FAILURE |
    typeof FETCH_API_LIST_REQUEST | typeof FETCH_API_LIST_SUCCESS | typeof FETCH_API_LIST_FAILURE | typeof FETCH_FEATURED_API_LIST_SUCCESS | typeof FEATCH_FEATURED_API_LIST_REQUEST | typeof FETCH_FEATURED_API_LIST_FAILURE |
    typeof FETCH_MAJOR_VERSION_API_LIST_REQUEST | typeof FETCH_MAJOR_VERSION_API_LIST_SUCCESS | typeof FETCH_MAJOR_VERSION_API_LIST_FAILURE |
    typeof FETCH_THUMBNAIL_REQUEST | typeof FETCH_THUMBNAIL_SUCCESS | typeof FETCH_THUMBNAIL_FAILURE |
    typeof FETCH_THUMBNAIL_LIST_REQUEST | typeof FETCH_THUMBNAIL_LIST_SUCCESS | typeof FETCH_THUMBNAIL_LIST_FAILURE | 
    typeof SET_SECURITY_HEADERS,
    payload?: Api | ApiList | Blob | string | ApiRequestHeader | { [key: string]: string }
}
